import React from "react";
import { useNavigate } from "react-router-dom";
import { Crown, ChevronRight } from "lucide-react";

export const VIP_TILE = { k: "vip", l: "VIP Signals & Algo", d: "Premium services join karein", icon: Crown, to: "/vip" };

export const SeeMore = ({ onClick, testid }) => (
  <button onClick={onClick} data-testid={testid} className="text-xs text-gold flex items-center gap-0.5 hover:underline">See more<ChevronRight size={14} /></button>
);

export function MenuTiles({ items, onPick }) {
  const nav = useNavigate();
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="menu-tiles">
      {items.map((t, i) => (
        <button key={t.k} data-testid={`tile-${t.k}`} onClick={() => (t.to ? nav(t.to) : onPick(t.k))}
          style={{ animationDelay: `${i * 60}ms`, animationFillMode: "both" }}
          className={`group surface p-4 sm:p-5 text-left flex flex-col gap-3 min-h-[120px] animate-in fade-in slide-in-from-bottom-2 duration-500 hover:-translate-y-0.5 hover:border-gold transition-[transform,border-color] duration-200 ${t.to ? "border-gold/60" : ""}`}>
          <div className={`w-11 h-11 flex items-center justify-center ${t.to ? "bg-gold text-black" : "bg-[color:var(--gold)]/10 text-gold"}`}>
            <t.icon size={22} />
          </div>
          <div className="mt-auto">
            <div className="text-white font-semibold text-sm flex items-center gap-1">{t.l}<ChevronRight size={14} className="text-slate-500 group-hover:text-gold group-hover:translate-x-0.5 transition-transform duration-200" /></div>
            {t.d && <div className="text-[11px] text-slate-500 mt-0.5 leading-snug">{t.d}</div>}
          </div>
        </button>
      ))}
    </div>
  );
}
